<template>
    <validation-observer ref="test_email_form" v-slot="{ meta }">
        <modal
            :id="modalId"
            :title="`Send Test ${actionTypeText}`"
            :ok-disabled="!meta.valid || busy"
            @show="onShow"
            @ok.prevent="sendMessage"
        >
            <div class="w-100 d-flex flex-column">
                <busy-modal :show="busy" />
                <b-row>
                    <b-col>
                        <validation-provider
                            v-if="isEmail"
                            name="email"
                            v-slot="{ errors, handleChange }"
                            rules="email|required"
                            
                        >
                            <form-input
                                v-model="email"
                                floatingLabel="Email"
                                :error="errors[0]"
                                @input="handleChange"
                            />
                        </validation-provider>
                        <validation-provider
                            v-else
                            name="sms_recipient"
                            v-slot="{ errors, handleChange }"
                            rules="required"
                            
                        >
                            <form-select
                                :options="sendToOptions"
                                v-model="recipientType"
                                :error="errors[0]"
                                @change="handleChange"
                            />
                        </validation-provider>
                        <validation-provider
                            v-if="!isEmail && recipientType === 'TEAM_MEMBER'"
                            name="team_member"
                            v-slot="{ errors, handleChange }"
                            rules="required"
                            
                        >
                            <form-select
                                :options="teamMembersOptions"
                                v-model="teamMember"
                                :error="errors[0]"
                                @change="handleChange"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <form-select :options="propertiesOptions" v-model="property" floatingLabel="Property" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="guest" v-slot="{ errors, handleChange }" rules="required" >
                            <form-select
                                :options="guestOptions"
                                v-model="guest"
                                floatingLabel="Guest"
                                :error="errors[0]"
                                @change="handleChange"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span class="text-primary">
                            <font-awesome-icon :icon="['fas', 'circle-info']" />
                            Test trigger use test data. No real reservation will be created.
                        </span>
                    </b-col>
                </b-row>
            </div>
        </modal>
    </validation-observer>
</template>

<script>
    import { mapGetters } from 'vuex';

    import api from '../../../../api';

    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import Modal from '../../../generic/modal/modal.vue';
    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormSelect from '../../../generic/form-select/form-select.vue';

    export default {
        name: 'TriggerTestModal',
        props: {
            actionType: {
                type: String,
                default: '',
            },
            modalId: {
                type: String,
                default: '',
            },
            busy: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            Modal,
            FormInput,
            FormSelect,
            BusyModal,
        },
        data() {
            return {
                email: '',
                property: null,
                guest: null,
                guests: [],
                sms_phone: '',
                recipientType: 'SUBSCRIBER',
                teamMember: '',
            };
        },
        computed: {
            ...mapGetters('trigger', ['propertiesOptions', 'teamMembersOptions']),
            ...mapGetters('header', ['userUnicodeDateFormat', 'userEmail']),
            defaultSmsCountryCode() {
                if (this.sms_phone) {
                    const phone = PhoneNumber(this.sms_phone);
                    return phone.g.regionCode;
                } else {
                    return this.$store.getters['account/code'];
                }
            },
            guestOptions() {
                return this.guests.map((item) => ({
                    text: item.full_name,
                    value: item.id,
                }));
            },
            sendToOptions() {
                return [
                    {
                        value: 'SUBSCRIBER',
                        text: 'Subscriber',
                    },
                    {
                        value: 'TEAM_MEMBER',
                        text: 'Team Member',
                    },
                ];
            },
            actionTypeText() {
                if (this.actionType === 'EMAIL') {
                    return 'Email';
                } else if (this.actionType === 'PUSH') {
                    return 'Push Notification';
                } else {
                    return 'SMS';
                }
            },
            isEmail() {
                return this.actionType === 'EMAIL';
            },
        },
        methods: {
            async onShow() {
                await this.fetchGuests();
                this.property = this.propertiesOptions.length && this.propertiesOptions[0].value;
                this.guest = this.guestOptions.length && this.guestOptions[0].value;
                this.email = this.userEmail;
                this.teamMember = this.teamMembersOptions.length ? this.teamMembersOptions[0].value : '';
                this.$refs.test_email_form.setValues({
                    guest: this.guest,
                    email: this.email,
                    team_member: this.teamMember,
                    sms_recipient: this.sms_phone,
                });
            },
            async fetchGuests() {
                try {
                    const { data } = await api.get(
                        '/app/reservation/details/guest-list/?first_name=&last_name=&email='
                    );
                    this.guests = data;
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch guests.' });
                }
            },
            sendMessage() {
                const values = {
                    rental_property: this.property,
                    guest: this.guest,
                };
                if (this.isEmail) {
                    values.email = this.email;
                } else {
                    values.recipient_type = this.recipientType;
                    if (this.recipientType === 'TEAM_MEMBER') {
                        values.team_member = this.teamMember;
                    }
                }
                this.$emit('submit', values);
            },
            onValidateSmsPhone(value) {
                this.$refs.mobilePhone.validate();
                if (value.isValid) {
                    this.sms_phone = value.number.e164;
                }
            },
        },
    };
</script>

<style></style>
